/**
 * A phone number as the phone dials it: digits and a leading plus, nothing a
 * person typed to make it readable. One place, so `tel:` and `sms:` links
 * cannot disagree about what "0412 345 678" is.
 */
export function dialable(phone: string | null | undefined): string {
  return phone ? phone.replace(/[^\d+]/g, '') : ''
}

/** A `tel:` link, or null when there is no number to ring. */
export function telHref(phone: string | null | undefined): string | null {
  const number = dialable(phone)
  return number ? `tel:${number}` : null
}
